// Generated from ContestRouteAssign's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type ContestRouteAssignCollectionFilterGroups
  = | {
    readonly categoryContest: Iri
  }

export const contestRouteAssignCollectionFilterMapping: FilterDefinitionMapping<ContestRouteAssignCollectionFilterGroups> = {
  categoryContest: 'category.contest',
}

export type ContestRouteAssignCollectionSort = never
